import {
  IconButton,
  TextField,
  Button,
  Badge,
  MenuItem,
  Divider,
  Menu,
  Popover,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  getRequisition,
  getWrittenExams,
  getOralExams,
  getReportedCandidatesPassedExam,
  onConfirmApplicationOnReportedAdvert,
} from "../../../store/recruitment/actions";
import { getUserDetails } from "../../../store/profile/actions";
import RequisitionDetailsDialog from "./RequisitionDetailsDialog";
import AllCandidatesShortlistedDialog from "./AllCandidatesShortlistedDialog";
import AllCandidatesResultsDialog from "./AllCandidatesResultsDialog";
import AllCandidatesOnWaitingDialog from "./AllCandidatesOnWaitingDialog";
import AllCandidatesOnWrittenDialog from "./AllCandidatesOnWrittenDialog";
import AllCandidatesOnOralDialog from "./AllCandidatesOnOralDialog";
import WrittenExamDetailDialog from "./WrittenExamDetailDialog";
import OralExamDetailDialog from "./OralExamDetailDialog";
import { showError } from "../../toastify";
import PreviewPdfUrl from "../../common/components/PreviewPdfUrl";
import axios from "axios";
import NpscOverallResultsDialog from "../pages/NpscOverallResultsDialog";
import WrittenExamMarking from "./WrittenExamMarking";
import OralExamMarking from "./OralExamMarking";
import ManageWrittenExamQuestionDialog from "./ManageWrittenExamQuestionDialog";
import Panelist from "./Panelist";
import Invigilator from "./Invigilator";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import UserResume from "../../profile/UserResume";
import ApplicationCv from "../../common/components/ApplicationCv";
import ApplicantDetails from "./ApplicantDetails";
import WidgetViewContentDialog from "../../common/components/WidgetViewContentDialog";
import ViewApplicationEmploymentAttachments from "./ViewApplicationEmploymentAttachments";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import PdfViewer from "../../common/components/PdfViewer";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const AdvertisementReport = (props) => {
  const {
    loading,
    details,
    getRequisition,
    getWrittenExams,
    getOralExams,
    oralExams,
    writtenExams,
    getReportedCandidatesPassedExam,
    reportedCandidatesPassedExam,
    viewLess,
    onConfirmApplicationOnReportedAdvert,
  } = props;

  const [
    showAllCandidatesShortlistedDialog,
    setShowAllCandidatesShortlistedDialog,
  ] = useState(false);
  const [showOverallResult, setShowOverallResult] = useState(false);
  const { hasPermissions } = useRequiredAuth();
  const [
    showAllCandidatesOnWrittenDialog,
    setShowAllCandidatesOnWrittenDialog,
  ] = useState(false);
  const [showAllCandidatesOnOralDialog, setShowAllCandidatesOnOralDialog] =
    useState(false);
  const [showAllCandidatesResultsDialog, setShowAllCandidatesResultsDialog] =
    useState(false);

  const [
    showAllCandidatesOnWaitingDialog,
    setShowAllCandidatesOnWaitingDialog,
  ] = useState(false);

  const [showRequisitionDetails, setShowRequisitionDetails] = useState(false);
  const [selectedRequisition, setSelectedRequisition] = useState(null);
  const [showWrittenExamDetail, setShowWrittenExamDetail] = useState(false);
  const [showOralExamDetail, setShowOralExamDetail] = useState(false);

  const [showDocument, setShowDocument] = useState(false);
  const [documentQuestions, setDocumentQuestions] = useState({});
  const [reportSummary, setReportSummary] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [
    showUploadWrittenExamQuestionsForm,
    setShowUploadWrittenExamQuestionsForm,
  ] = useState(false);
  const [showInvigilators, setShowInvigilators] = useState(false);
  const [showPanelLists, setShowPanelLists] = useState(false);
  const [showOralExamMarking, setShowOralExamMarking] = useState(false);
  const [showWrittenExamMarking, setShowWrittenExamMarking] = useState(false);
  const [currentWrittenExam, setCurrentWrittenExam] = useState(
    writtenExams.find(({ isCanceled }) => !isCanceled)
  );
  const [currentOralExam, setCurrentOralExam] = useState(
    oralExams.find(({ isCanceled }) => !isCanceled)
  );

  useEffect(() => {
    if (!!details?.willHaveWrittenExam) {
      getWrittenExams(details.advertisementId, setIsLoading);
    }
    if (!!details?.willHaveOralExam) {
      getOralExams(details.advertisementId, setIsLoading);
    }
    if (!viewLess) getNpscReportSummary();
    if (!viewLess) getReportedCandidatesPassedExam(details.advertisementId);
  }, []);
  useEffect(() => {
    setCurrentWrittenExam(writtenExams.find(({ isCanceled }) => !isCanceled));
    setCurrentOralExam(oralExams.find(({ isCanceled }) => !isCanceled));
  }, [writtenExams, oralExams]);

  const onViewOralExamQuestions = async () => {
    try {
      const { data } = await axios.get(
        `/api/recruitment/advertised-oral-exam-questions/${details.advertisementId}`
      );

      setDocumentQuestions({
        url: data,
        name: "Oral exam prepared questions",
      });
      setShowDocument(true);
    } catch (error) {
      showError(error);
    }
  };
  const getNpscReportSummary = async () => {
    try {
      const { data } = await axios.get(
        `/api/recruitment/reports/advertisement/summary/${details.advertisementId}`
      );

      setReportSummary(data);
    } catch (error) {
      showError(error);
    }
  };

  return (
    <>
      <div
        className="card service-card mt-0 mb-2"
        style={{ borderColor: "#e0edf9!important" }}
      >
        <table className="table table-striped table-hover table-sm w-100  fixTableHead">
          <caption
            style={{ backgroundColor: "#1976d2", color: "#fff" }}
            className="mb-0"
          >
            {details?.positionName || ""}
          </caption>

          <thead>
            <tr style={{ backgroundColor: "#f0f2f5" }}>
              <th>List</th>
              <th className="text-right">Actions</th>
            </tr>
          </thead>

          <tbody>
            <tr className="py-2 appeal-hovered">
              <td>1. Job profile. </td>

              <td className="float-right">
                {" "}
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  disabled={loading}
                  onClick={() => {
                    getRequisition(
                      details?.requisitionId,
                      setShowRequisitionDetails,
                      setSelectedRequisition
                    );
                  }}
                  className="text-right "
                >
                  Open
                </Button>
              </td>
            </tr>

            <tr className="py-2 appeal-hovered">
              <td>2. All applications. </td>

              <td className="float-right">
                {" "}
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  disabled={loading}
                  onClick={() => {
                    setShowAllCandidatesShortlistedDialog(true);
                  }}
                  className="text-right "
                >
                  Open
                </Button>
              </td>
            </tr>
            <tr className="py-2 appeal-hovered">
              <td>6. Exam schedule. </td>

              <td className="float-right">
                {" "}
                {!!details?.willHaveWrittenExam && currentWrittenExam && (
                  <Button
                    variant="outlined"
                    color="info"
                    size="small"
                    disabled={loading}
                    onClick={() => {
                      setShowWrittenExamDetail(true);
                    }}
                    className="mr-3"
                  >
                    Written
                  </Button>
                )}
                {!!details?.willHaveOralExam && currentOralExam && (
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    disabled={loading}
                    onClick={() => {
                      setShowOralExamDetail(true);
                    }}
                  >
                    Oral
                  </Button>
                )}
              </td>
            </tr>
            <tr className="py-2 appeal-hovered">
              <td>3. Exam attendance. </td>

              <td className="float-right">
                {" "}
                {!!details?.willHaveWrittenExam && currentWrittenExam && (
                  <Button
                    variant="outlined"
                    color="info"
                    size="small"
                    disabled={loading}
                    onClick={() => {
                      setShowAllCandidatesOnWrittenDialog(true);
                    }}
                    className="mr-3"
                  >
                    Written
                  </Button>
                )}
                {!!details?.willHaveOralExam && currentOralExam && (
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    disabled={loading}
                    onClick={() => {
                      setShowAllCandidatesOnOralDialog(true);
                    }}
                  >
                    Oral
                  </Button>
                )}
              </td>
            </tr>
            <tr className="py-2 appeal-hovered">
              <td>4.Exam results. </td>

              <td className="float-right">
                {" "}
                {!!details?.willHaveWrittenExam && !!currentWrittenExam && (
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    disabled={loading}
                    onClick={() => {
                      setShowWrittenExamMarking(true);
                    }}
                    className="text-right mr-2"
                  >
                    Written
                  </Button>
                )}
                {!!details?.willHaveOralExam && currentOralExam && (
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    disabled={loading}
                    onClick={() => {
                      setShowOralExamMarking(true);
                    }}
                    className="text-right mr-2"
                  >
                    Oral
                  </Button>
                )}
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  disabled={loading}
                  onClick={() => {
                    setShowOverallResult(true);
                  }}
                  className="text-right "
                >
                  Overall
                </Button>
              </td>
            </tr>
            <tr className="py-2 appeal-hovered">
              <td>4.Waiting list. </td>

              <td className="float-right">
                {" "}
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  disabled={loading}
                  onClick={() => {
                    setShowAllCandidatesOnWaitingDialog(true);
                  }}
                  className="text-right "
                >
                  Open
                </Button>
              </td>
            </tr>

            <tr className="py-2 appeal-hovered">
              <td>7.Exam questionnaire and marking scheme </td>

              <td className="float-right">
                {" "}
                {!!details?.willHaveWrittenExam && currentWrittenExam && (
                  <Button
                    variant="outlined"
                    color="info"
                    size="small"
                    disabled={loading}
                    onClick={() => {
                      setShowUploadWrittenExamQuestionsForm(true);
                    }}
                    className="mr-3"
                  >
                    Written
                  </Button>
                )}
                {!!details?.willHaveOralExam && currentOralExam && (
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    disabled={loading}
                    onClick={() => {
                      onViewOralExamQuestions();
                    }}
                  >
                    Oral
                  </Button>
                )}
              </td>
            </tr>

            <tr className="py-2 appeal-hovered">
              <td>8. Examiners. </td>

              <td className="float-right py-2 px-2">
                {!!details?.willHaveWrittenExam && currentWrittenExam && (
                  <Button
                    variant="outlined"
                    color="info"
                    size="small"
                    disabled={loading}
                    onClick={() => {
                      setShowInvigilators(true);
                    }}
                    className="mr-3"
                  >
                    Written
                  </Button>
                )}
                {!!details?.willHaveOralExam && currentOralExam && (
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    disabled={loading}
                    onClick={() => {
                      setShowPanelLists(true);
                    }}
                  >
                    Oral
                  </Button>
                )}
              </td>
            </tr>
            <tr className="appeal-hovered">
              <td>9. Recorded video and audio for the oral interview. </td>

              <td className="float-right">To Be Submitted Manually</td>
            </tr>
          </tbody>
        </table>
      </div>
      {!viewLess && (
        <div
          className="card service-card mt-5 mt-0"
          style={{ borderColor: "#e0edf9!important" }}
        >
          <div
            className="card-header"
            style={{ padding: "0.25rem 1.2rem", width: "100%" }}
          >
            <div className="row">
              <div className="col-lg-12">10. Summary by gender. </div>
            </div>
          </div>
          <div
            className="pb-2"
            style={{ overflowX: "auto", maxWidth: "100vw" }}
          >
            <table className="table table-striped table-hover table-sm w-100  fixTableHead">
              <tbody>
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      borderRight: "1px solid rgb(150, 171, 181)",
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                    className="text-center"
                  >
                    Applications
                  </td>
                  <td
                    colSpan={3}
                    style={{
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                    className="text-center"
                  >
                    Shortlisted
                  </td>
                  <td
                    colSpan={3}
                    style={{
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                    className="text-center"
                  >
                    NotShortlisted
                  </td>

                  <td
                    colSpan={3}
                    style={{
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                    className="text-center"
                  >
                    WrittenAttended
                  </td>
                  <td
                    colSpan={3}
                    style={{
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                    className="text-center"
                  >
                    OralAttended
                  </td>
                  <td
                    colSpan={3}
                    style={{
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                    className="text-center"
                  >
                    SucceedInAllExams.
                  </td>

                  <td
                    colSpan={3}
                    style={{
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                    className="text-center"
                  >
                    Hired.
                  </td>

                  <td
                    colSpan={3}
                    style={{
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                    className="text-center"
                  >
                    OnWaitingList.
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Male
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Female
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Total
                  </td>

                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Male
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Female
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Total
                  </td>

                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Male
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Female
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Total
                  </td>

                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Male
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Female
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Total
                  </td>

                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Male
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Female
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Total
                  </td>

                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Male
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Female
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Total
                  </td>

                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Male
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Female
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Total
                  </td>

                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Male
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Female
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    Total
                  </td>
                </tr>

                <tr>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalApplicantMale || 0}
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalApplicantFemale || 0}
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalNumberOfApplicant || 0}
                  </td>

                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalMaleShortlisted || 0}
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalFemaleShortlisted || 0}
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalShortlisted || 0}
                  </td>

                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalMaleNotShortlisted || 0}
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalFemaleNotShortlisted || 0}
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalNotShortlisted || 0}
                  </td>

                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalWrittenMaleAttended || 0}
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalWrittenFemaleAttended || 0}
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalWrittenAttended || 0}
                  </td>

                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalOralMaleAttended || 0}
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalOralFemaleAttended || 0}
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalOralAttended || 0}
                  </td>

                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalSucceedMaleAttended || 0}
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalSucceedFemaleAttended || 0}
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalSucceedAttended || 0}
                  </td>

                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalMaleHired || 0}
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalFemaleHired || 0}
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalHired || 0}
                  </td>

                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalMaleOnWaitingList || 0}
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalFemaleOnWaitingList || 0}
                  </td>
                  <td
                    style={{
                      borderLeft: "1px solid rgb(150, 171, 181)",
                      borderRight: "1px solid rgb(150, 171, 181)",
                    }}
                  >
                    {reportSummary?.totalOnWaitingList || 0}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
      {!viewLess && (
        <>
          {!!reportedCandidatesPassedExam.length && (
            <div
              className="card service-card mt-5 mt-0"
              style={{ borderColor: "#e0edf9!important" }}
            >
              <div
                className="card-header"
                style={{ padding: "0.25rem 1.2rem", width: "100%" }}
              >
                <div className="row">
                  <div className="col-lg-12">View Candidates Passed Exam</div>
                </div>
              </div>
              <div
                className="pb-2"
                style={{ overflowX: "auto", maxWidth: "100vw" }}
              >
                <div className="mt-0">
                  <table className="table table-striped table-hover table-sm  fixTableHead">
                    <thead>
                      <tr style={{ backgroundColor: "#f0f2f5" }}>
                        <th scope="col" className="text-left">
                          Names
                        </th>
                        <th scope="col" className="text-left">
                          Email
                        </th>
                        <th scope="col" className="text-left">
                          PhoneNumber
                        </th>
                        <th scope="col" className="text-left">
                          IDNumber
                        </th>
                        <th scope="col" className="text-left">
                          Gender
                        </th>
                        <th className="text-left">Score</th>

                        <th scope="col" className="text-center">
                          Status
                        </th>

                        <th scope="col" colSpan={2} className="text-right">
                          Actions
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {reportedCandidatesPassedExam.map(
                        (application, index) => (
                          <EmployeeList
                            key={index}
                            application={application}
                            hasPermissions={hasPermissions}
                            loading={loading}
                            details={details}
                            onConfirmApplicationOnReportedAdvert={
                              onConfirmApplicationOnReportedAdvert
                            }
                          />
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {showRequisitionDetails && (
        <RequisitionDetailsDialog
          showRequisitionDetails={showRequisitionDetails}
          setShowRequisitionDetails={setShowRequisitionDetails}
          selectedRequisition={selectedRequisition}
        />
      )}
      {showAllCandidatesShortlistedDialog && (
        <AllCandidatesShortlistedDialog
          showDialog={showAllCandidatesShortlistedDialog}
          setShowDialog={setShowAllCandidatesShortlistedDialog}
          application={details}
        />
      )}
      {showAllCandidatesResultsDialog && (
        <AllCandidatesResultsDialog
          showDialog={showAllCandidatesResultsDialog}
          setShowDialog={setShowAllCandidatesResultsDialog}
          application={details}
        />
      )}
      {showAllCandidatesOnWaitingDialog && (
        <AllCandidatesOnWaitingDialog
          showDialog={showAllCandidatesOnWaitingDialog}
          setShowDialog={setShowAllCandidatesOnWaitingDialog}
          application={details}
        />
      )}
      {showAllCandidatesOnWrittenDialog && (
        <AllCandidatesOnWrittenDialog
          showDialog={showAllCandidatesOnWrittenDialog}
          setShowDialog={setShowAllCandidatesOnWrittenDialog}
          application={details}
          setShowWrittenExamDetail={setShowWrittenExamDetail}
        />
      )}

      {showAllCandidatesOnOralDialog && (
        <AllCandidatesOnOralDialog
          showDialog={showAllCandidatesOnOralDialog}
          setShowDialog={setShowAllCandidatesOnOralDialog}
          application={details}
          setShowOralExamDetail={setShowOralExamDetail}
        />
      )}
      {showWrittenExamDetail && (
        <WrittenExamDetailDialog
          showDialog={showWrittenExamDetail}
          setShowDialog={setShowWrittenExamDetail}
          application={details}
        />
      )}

      {showOralExamDetail && (
        <OralExamDetailDialog
          showDialog={showOralExamDetail}
          setShowDialog={setShowOralExamDetail}
          application={details}
        />
      )}
      {showDocument && (
        <PreviewPdfUrl
          isBase64={true}
          showDocument={showDocument}
          document={documentQuestions}
          setShowDocument={setShowDocument}
        />
      )}
      {showOverallResult && (
        <NpscOverallResultsDialog
          showOverallResult={showOverallResult}
          setShowOverallResult={setShowOverallResult}
          selectedAdvertisement={details}
        />
      )}
      {showWrittenExamMarking && (
        <WrittenExamMarking
          exam={currentWrittenExam}
          showWrittenExamMarking={showWrittenExamMarking}
          setShowWrittenExamMarking={setShowWrittenExamMarking}
          userType={""}
        />
      )}
      {showOralExamMarking && (
        <OralExamMarking
          exam={currentOralExam}
          showOralExamMarking={showOralExamMarking}
          setShowOralExamMarking={setShowOralExamMarking}
        />
      )}
      {showUploadWrittenExamQuestionsForm && (
        <ManageWrittenExamQuestionDialog
          exam={currentWrittenExam}
          selectedAdvertisement={details}
          showUploadWrittenExamQuestionsForm={
            showUploadWrittenExamQuestionsForm
          }
          setShowUploadWrittenExamQuestionsForm={
            setShowUploadWrittenExamQuestionsForm
          }
        />
      )}
      {showPanelLists && (
        <Panelist
          showPanelLists={showPanelLists}
          selectedExam={currentOralExam}
          setShowPanelLists={setShowPanelLists}
        />
      )}
      {showInvigilators && (
        <Invigilator
          showInvigilators={showInvigilators}
          selectedExam={currentOralExam}
          setShowInvigilators={setShowInvigilators}
        />
      )}
    </>
  );
};

const mapStateToProps = ({
  loading,
  oralExams,
  writtenExams,
  reportedCandidatesPassedExam,
}) => {
  return {
    loading,
    oralExams,
    writtenExams,
    reportedCandidatesPassedExam,
  };
};
export default connect(mapStateToProps, {
  getRequisition,
  getWrittenExams,
  getOralExams,
  getReportedCandidatesPassedExam,
  getUserDetails,
  onConfirmApplicationOnReportedAdvert,
})(AdvertisementReport);

const EmployeeList = (props) => {
  const {
    application,
    hasPermissions,
    loading,
    getUserDetails,
    onConfirmApplicationOnReportedAdvert,
    details,
  } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [showLetter, setsShowLetter] = useState(false);
  const [showWaitingListDialog, setShowWaitingListDialog] = useState(false);
  const [showStopServiceDialog, setShowStopServiceDialog] = useState(false);
  const [showApplicationCv, setShowApplicationCv] = useState(false);
  const [showCurrentProfile, setShowCurrentProfile] = useState(false);
  const [reason, setReason] = useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [documentDialog, setDocumentDialog] = useState(false);
  const [provAppointmentDocDialog, setProvAppointmentDocDialog] =
    useState(false);
  const [showRejectReasonDialog, setShowRejectReasonDialog] = useState(false);
  const [showApplicationLogsDialog, setShowApplicationLogsDialog] =
    useState(false);
  const [isLogsLoading, setIsLogsLoading] = useState(false);
  const [applicationLogs, setApplicationLogs] = useState([]);
  const [confirmEmployeeAnchorPosition, setConfirmEmployeeAnchorPosition] =
    useState(null);
  const [confirmEmployeeAction, setConfirmEmployeeAction] = useState("");
  const open = Boolean(anchorEl);
  const [showApplication, setShowApplication] = useState(false);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleOpenCurrentProfile = () => {
    handleCloseMenu();
    setShowCurrentProfile(true);
  };

  const canReviewInCurrentReport =
    [0, 1, 2].includes(+application.reportAdvertStatusId) &&
    [2].includes(+details.reportStatusId) &&
    !!hasPermissions(["IS_NPSC"]);
  const canApproveEmployee = [0, 2].includes(+application.reportApplicationStatusId);
  const canRejectEmployee = [0, 1].includes(+application.reportApplicationStatusId);
  const canAddToWaitingList =
    [1].includes(+application.reportApplicationStatusId) &&
    !application.waitingStatusId &&
    [3, 4, 6].includes(+application.offerStatusId);
  const canStopFromService =
    /employ|service/i.test(application?.offerStatusName || "") ||
    [5].includes(+application.offerStatusId);

  const handleOpenConfirmEmployeePopover = (event) => {
    if (!canReviewInCurrentReport || (!canApproveEmployee && !canRejectEmployee)) {
      return;
    }

    setConfirmEmployeeAction(
      canApproveEmployee ? "APPROVE" : canRejectEmployee ? "REJECT" : ""
    );
    setReason("");
    setConfirmEmployeeAnchorPosition({
      top: event.clientY,
      left: event.clientX,
    });
  };

  const handleCloseConfirmEmployeePopover = () => {
    setConfirmEmployeeAnchorPosition(null);
    setConfirmEmployeeAction("");
    setReason("");
  };

  const handleConfirmEmployeeDecision = () => {
    if (!confirmEmployeeAction || !reason) {
      return;
    }

    const isApprove = confirmEmployeeAction === "APPROVE";
    onConfirmApplicationOnReportedAdvert(
      {
        action: confirmEmployeeAction,
        statusId: isApprove ? 1 : 2,
        reason: reason,
        reportId: +details?.reportId,
        applicationId: application.id,
      },
      (isLoading, data) => {
        setIsLoading(isLoading);
        if (data) {
          handleCloseConfirmEmployeePopover();
        }
      }
    );
  };

  const loadApplicationLogs = async () => {
    try {
      // console.log(application);
      const reportApplicationId = application?.reportApplicationId;
      if (!reportApplicationId) {
        showError("Report application ID is missing.");
        return;
      }

      setShowApplicationLogsDialog(true);
      setIsLogsLoading(true);

      const { data } = await axios.get(
        `/api/recruitment/reports/adverts/applications/logs/${reportApplicationId}`
      );
      setApplicationLogs(Array.isArray(data) ? data : []);
    } catch (error) {
      setApplicationLogs([]);
      showError(error);
    } finally {
      setIsLogsLoading(false);
    }
  };

  const getLogAction = (log) =>
    log?.action || log?.actionName || log?.statusName || "Action";



  const getLogReason = (log) =>
    log?.message || log?.remarks || log?.remark || log?.comment;

  const getLogDate = (log) =>
    log?.actionOn || log?.createdOn || log?.updatedOn || log?.statusOn;
  // console.log(details);
  return (
    <tr>
      <td className="text-left">
        <span style={{ fontSize: "10px" }}>
          {application.lastName} {application.firstName}
        </span>
      </td>
      <td className="text-left">
        <span style={{ fontSize: "10px" }}>{application.email}</span>
      </td>
      <td className="text-left">
        <span style={{ fontSize: "10px" }}>{application.phoneNumber}</span>
      </td>
      <td className="text-left">
        <span style={{ fontSize: "10px" }}>{application.idNumber}</span>
      </td>
      <td className="text-left">
        <span style={{ fontSize: "10px" }}>
          {application.genderId === "M" ? "Male" : "Female"}
        </span>
      </td>
      <td className="text-left">
        <span style={{ fontSize: "10px" }}>
          {(application.score || 0).toFixed(2)}%
        </span>
      </td>

      <td className="text-center">
        <span className="d-flex flex-nowrap align-items-center justify-content-end">
        
          {!!application.waitingStatusId && (
            <span
              style={{ width: "68px" }}
              className={`mr-1 badge badge-pill text-${
                application.waitingStatusId === 2 ? "danger" : "primary"
              }`}
            >
              {application.waitingStatusId === 1
                ? "On waiting"
                : application.waitingStatusId === 2
                ? "Waiting expired"
                : ""}
            </span>
          )}

          {+application.reportApplicationStatusId > 0 && (
            <>
              <span
                style={{ width: "80px" }}
                className={` mr-1 px-1 badge badge-${
                  [1].includes(application.reportApplicationStatusId)
                    ? "info"
                    : "danger"
                }`}
              >
                {application.reportApplicationStatusName}
              </span>
             
            </>
          )}
            {application.offerStatusId && (
            <span
              style={{ width: "80px" }}
              className={` mr-1 px-1 badge badge-${
                [2, 5].includes(application.offerStatusId)
                  ? "success"
                  : [3, 4].includes(application.offerStatusId)
                  ? "danger"
                  : application.offerStatusName === "Offer expired"
                  ? "warning"
                  : "primary"
              }`}
            >
              {application.offerStatusName}
            </span>
          )}
        </span>
      </td>

      <td className="text-right">
       
          {showWaitingListDialog && (
                    <ConfirmationDialog
                      size="md"
                      disabled={!reason}
                      confirmationDialog={showWaitingListDialog}
                      message={
                        <>
                         <div className="p-2">
                          Are you sure you want to move this candidate to the <span className="text-warning">waiting list</span>? 
                          <p>
                          <strong>{application.lastName} {application.firstName}</strong>
                          </p>

                          <p className="p-2">
                         <TextField
                            fullWidth
                            size="small"
                            multiline
                            rows={4}
                            name="reason"
                            label="Type your remark .."
                            variant="outlined"
                            placeholder="Type your remark  .."
                            value={reason}
                            onChange={(e) => {
                              setReason(e.target.value || "");
                            }}
                          />
                         </p>
                         </div>
                        </>
                      }
                      setConfirmationDialog={setShowWaitingListDialog}
                      onYes={() => {
                        onConfirmApplicationOnReportedAdvert(
                          {
                            action:"ADD_TO_WAITING_LIST",
                            statusId: application.reportApplicationStatusId,
                            reason: reason,
                            reportId: +details?.reportId,
                            applicationId: application.id,
                          },
                          (isLoading, data) => {
                            setIsLoading(isLoading);
                            if (data) {
                              setShowWaitingListDialog(false);
                            }
                          }
                        );
                      }}
                    />
                  )}
                  {showStopServiceDialog && (
                    <ConfirmationDialog
                      size="md"
                      disabled={!reason}
                      confirmationDialog={showStopServiceDialog}
                      message={
                        <>
                          <div className="p-2">
                            Are you sure you want to stop this employee from{" "}
                            <span className="text-danger">service</span>?
                            <p>
                              <strong>
                                {application.lastName} {application.firstName}
                              </strong>
                            </p>
                            <p className="p-2">
                              <TextField
                                fullWidth
                                size="small"
                                multiline
                                rows={4}
                                name="reason"
                                label="Type your remark .."
                                variant="outlined"
                                placeholder="Type your remark  .."
                                value={reason}
                                onChange={(e) => {
                                  setReason(e.target.value || "");
                                }}
                              />
                            </p>
                          </div>
                        </>
                      }
                      setConfirmationDialog={setShowStopServiceDialog}
                      onYes={() => {
                        onConfirmApplicationOnReportedAdvert(
                          {
                            action: "STOP_FROM_SERVICE",
                            statusId: application.reportApplicationStatusId,
                            reason: reason,
                            reportId: +details?.reportId,
                            applicationId: application.id,
                          },
                          (isLoading, data) => {
                            setIsLoading(isLoading);
                            if (data) {
                              setShowStopServiceDialog(false);
                            }
                          }
                        );
                      }}
                    />
                  )}
        {showApplication && (
          <ApplicantDetails
            applicantId={application?.id}
            showApplication={showApplication}
            setShowApplication={setShowApplication}
          />
        )}
        {showRejectReasonDialog && (
          <ConfirmationDialog
          size="md"
            disabled={true}
            confirmationDialog={showRejectReasonDialog}
            message={
              <>
                <div
                  style={{ minWidth: "200px" }}
                  className="w-100  float-start"
                >
                  <div className="d-flex flex-row justify-content-start mt-0 mr-3 w-100 float-start">
                    <div
                      className="card  w-100"
                      style={{
                        backgroundColor: "#fff",
                        borderLeft: "2px solid #3f51b5",
                        borderLeft: "2px solid #3f51b5",
                        borderRadius: "4px",
                      }}
                    >
                      <div className="card-body w-100 text-left">
                        {application.reportApproverReason && (
                          <p className="small pb-3 ms-2 mb-0 rounded-3 text-left">
                            Reason: {application.reportApproverReason}
                          </p>
                        )}

                        <p className="small p-0 ms-2 mb-0 rounded-3 text-left">
                          Confirmed by: {application.reportApprover}
                        </p>
                        <p className="small p-0 ms-2 mb-0 rounded-3 text-left">
                          Confirmed on:
                          {moment(application.reportApprovedOn).format("llll")}
                        </p>
                         <p className="mt-3">
<div className="row">
                            <div className="col">
                              <Link
                                onClick={() => {
                                  setDocumentDialog(true);
                                }}
                                className="text-dark font-weight-light"
                              >
                                <AttachFileIcon className="mr-2 text-primary" />

                                <>Employment Documents</>
                              </Link>
                            </div>
                            <div className="col">
                              {!!application.provAppointmentDocId && (
                                <Link
                                  onClick={() => {
                                    setProvAppointmentDocDialog(true);
                                  }}
                                  className="text-dark font-weight-light"
                                >
                                  <AttachFileIcon className="mr-2 text-success" />

                                  <>Provision Appoint. Letter</>
                                </Link>
                              )}
                            </div>
                          </div>
                         </p>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            }
            setConfirmationDialog={setShowRejectReasonDialog}
            onYes={() => {
              setShowRejectReasonDialog(false);
            }}
          />
        )}
      </td>
      <td className="text-right">
        <IconButton
          size="small"
          className="ml-2"
          onClick={handleOpenMenu}
          // onMouseMove={handleOpenMenu}
          aria-label="settings"
        >
          <Badge color="info">
            <span className="material-icons">more_vert</span>
          </Badge>
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleCloseMenu}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "auto",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 2,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 15,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >

          <MenuItem
            disabled={
              loading ||
              !canReviewInCurrentReport ||
              (!canApproveEmployee && !canRejectEmployee)
            }
            onClick={(event) => {
              handleCloseMenu();
              handleOpenConfirmEmployeePopover(event);
            }}
            className="text-dark font-weight-light"
          >
            <span
              className={`material-icons mr-1 ${
                canApproveEmployee
                  ? "text-success"
                  : canRejectEmployee
                  ? "text-danger"
                  : "text-info"
              }`}
            >
              verified_user
            </span>
            <span
              className={
                canApproveEmployee
                  ? "text-success"
                  : canRejectEmployee
                  ? "text-danger"
                  : "text-info"
              }
            >
              {(canApproveEmployee || canRejectEmployee)
                ? canApproveEmployee
                  ? "Approve"
                  : "Reject"
                : "Confirm"}{" "}
              employee
            </span>
          </MenuItem>
          <Divider className="my-1" />
          <MenuItem
            disabled={loading || !!application.canAddToWaitingList || [0].includes(+application.reportApplicationStatusId) || !canReviewInCurrentReport || !canAddToWaitingList}
            onClick={() => {
              handleCloseMenu();
              setReason("");
              setShowWaitingListDialog(true);
            }}
            className="text-dark font-weight-light"
          >
            <span className="material-icons mr-1 text-warning">playlist_add</span>
            Add to Waiting List
          </MenuItem>
          <Divider className="my-1" />
          <MenuItem
            disabled={loading || !!application.canStopFromService || [0].includes(+application.reportApplicationStatusId) || !canStopFromService}
            onClick={() => {
              handleCloseMenu();
              setReason("");
              setShowStopServiceDialog(true);
            }}
            className="text-dark font-weight-light"
          >
            <span className="material-icons mr-1 text-danger">person_off</span>
            Stop from service
          </MenuItem>
          <span>
            <MenuItem
              onClick={() => {
                handleCloseMenu();
                setShowApplication(true);
              }}
              className="text-dark font-weight-light"
            >
              <span className="material-icons mr-1">open_in_new</span>
              View details
            </MenuItem>
          </span>
          <Divider className="my-1" />
          <MenuItem
            onClick={() => {
              handleCloseMenu();
              setDocumentDialog(true);
            }}
            className="text-dark font-weight-light"
          >
            <AttachFileIcon className="mr-2 text-primary" />

            <>Employment Documents</>
          </MenuItem>

          {!!application.provAppointmentDocId && (
            <>
              <Divider className="my-1" />
              <MenuItem
                onClick={() => {
                  handleCloseMenu();
                  setProvAppointmentDocDialog(true);
                }}
                className="text-dark font-weight-light"
              >
                <AttachFileIcon className="mr-2 text-success" />

                <>Provision Appoint. Letter</>
              </MenuItem>
            </>
          )} 

          <span>
          <Divider className="my-1" />
            <MenuItem
              disabled={loading}
              onClick={() => {
                handleCloseMenu();
                setShowApplicationCv(true);
              }}
              className="text-dark font-weight-light"
            >
              <span className="material-icons mr-1">open_in_new</span>
              Application Profile
            </MenuItem>
          </span>
          <Divider className="my-1" />
          <MenuItem
            disabled={loading}
            onClick={() => {
              getUserDetails(application.userId, handleOpenCurrentProfile);
            }}
            className="text-dark font-weight-light"
          >
            {" "}
            <span className="material-icons mr-1 text-primary">
              open_in_new
            </span>
            {loading ? "Wait...." : "Currently Profile"}
          </MenuItem>
          {!!application.provAppointmentDocId && (
            <>
              <Divider className="my-1" />
              <MenuItem
                disabled={loading}
                onClick={() => {
                  setsShowLetter(true);
                }}
                className="text-dark font-weight-light"
              >
                <span className="material-icons mr-1 text-primary">
                  newspaper
                </span>
                Prov. Appointment Letter
              </MenuItem>
            </>
          )}
            {application?.reportApplicationId &&  
            <span>
            <Divider className="my-1" />  
            <MenuItem
            onClick={() => {
              handleCloseMenu();
              loadApplicationLogs();
            }}
            className="text-dark font-weight-light"
          >
            <span className="material-icons mr-1 text-info">history</span>
            Logs
          </MenuItem>
          </span>
          }
         
        </Menu>
      </td>

      <Popover
        open={!!confirmEmployeeAnchorPosition}
        onClose={handleCloseConfirmEmployeePopover}
        anchorReference="anchorPosition"
        anchorPosition={
          confirmEmployeeAnchorPosition
            ? {
                top: confirmEmployeeAnchorPosition.top,
                left: confirmEmployeeAnchorPosition.left,
              }
            : undefined
        }
      >
        <Card sx={{ minWidth: 360, maxWidth: 420 }}>
          <CardHeader
            sx={true}
            title="Confirm employee"
            subheader="Choose action and provide remark"
            action={
              <IconButton onClick={handleCloseConfirmEmployeePopover}>
                <span className="material-icons">close</span>
              </IconButton>
            }
          />
          <Divider />
          <CardContent>
            <FormControl component="fieldset">
              <RadioGroup
                value={confirmEmployeeAction}
                onChange={(e) => setConfirmEmployeeAction(e.target.value)}
              >
                <FormControlLabel
                  value="APPROVE"
                  control={<Radio size="small" />}
                  label="Approve employee"
                  disabled={!canApproveEmployee}
                />
                <FormControlLabel
                  value="REJECT"
                  control={<Radio size="small" />}
                  label="Reject employee"
                  disabled={!canRejectEmployee}
                />
              </RadioGroup>
            </FormControl>
            <TextField
              fullWidth
              size="small"
              multiline
              rows={3}
              name="reason"
              label="Type your remark .."
              variant="outlined"
              placeholder="Type your remark .."
              value={reason}
              onChange={(e) => setReason(e.target.value || "")}
            />
          </CardContent>
          <Divider />
          <CardActions className="px-3 py-2">
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleCloseConfirmEmployeePopover}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color={confirmEmployeeAction === "REJECT" ? "error" : "success"}
              disabled={!confirmEmployeeAction || !reason || isLoading}
              onClick={handleConfirmEmployeeDecision}
            >
              {isLoading ? "Processing..." : "Confirm"}
            </Button>
          </CardActions>
        </Card>
      </Popover>

      {documentDialog && (
        <WidgetViewContentDialog
          openDialog={documentDialog}
          maxWidth="md"
          content={
            <>
              <ViewApplicationEmploymentAttachments
                applicationId={application.id}
                canEdit={hasPermissions(["IS_HR"])}
              />
            </>
          }
          title={<>View Application Documents</>}
          setOpenDialog={setDocumentDialog}
        />
      )}

      {provAppointmentDocDialog && (
        <WidgetViewContentDialog
          openDialog={provAppointmentDocDialog}
          maxWidth="md"
          content={
            <>
              <PdfViewer
                url={
                  process.env.REACT_APP_FILES_URL +
                  "/preview/" +
                  application?.provAppointmentDocId
                }
              />
            </>
          }
          title={<>View Provisional Appointment</>}
          setOpenDialog={setProvAppointmentDocDialog}
        />
      )}

      {showCurrentProfile && (
        <UserResume
          showProfileDialog={showCurrentProfile}
          setShowProfileDialog={setShowCurrentProfile}
        />
      )}
      {showApplicationCv && (
        <ApplicationCv
          showApplicationCv={showApplicationCv}
          setShowApplicationCv={setShowApplicationCv}
          application={{
            id: application.id,
            idNumber: application.idNumber,
            phoneNumber: application.phoneNumber,
            userId: application.userId,
            lastName: application.lastName,
            firstName: application.firstName,
            email: application.email,
          }}
        />
      )}
      {showApplicationLogsDialog && (
        <WidgetViewContentDialog
          openDialog={showApplicationLogsDialog}
          maxWidth="md"
          title={
            <>
              Application Logs - {application.lastName} {application.firstName}
            </>
          }
          setOpenDialog={setShowApplicationLogsDialog}
          content={
            <div className="p-2" style={{ minWidth: "620px", maxWidth: "100%" }}>
              {isLogsLoading && (
                <div className="d-flex justify-content-center align-items-center py-4">
                  <span
                    className="spinner-border spinner-border-sm mr-2"
                    role="status"
                  ></span>
                  Loading logs...
                </div>
              )}
              {!isLogsLoading && !applicationLogs.length && (
                <div className="text-center text-muted py-4">
                  No logs found for this application.
                </div>
              )}
              {!isLogsLoading && !!applicationLogs.length && (
                <div style={{ maxHeight: "65vh", overflowY: "auto" }}>
                  {applicationLogs.map((log, index) => {
                    const action = getLogAction(log);
                    const by = log.names;
                    const reason = getLogReason(log);
                    const logDate = getLogDate(log);
                    return (
                      <div
                        key={log?.id || `${action}-${index}`}
                        className="card mb-2 border-0 shadow-sm"
                        style={{ borderLeft: "4px solid #1976d2" }}
                      >
                        <div className="card-body py-2 px-3">
                          <div className="d-flex justify-content-between align-items-start flex-wrap">
                            <div className="mb-1">
                              <span className="badge badge-info px-2 py-1">
                                {action}
                              </span>
                            </div>
                            <small className="text-muted">
                              {logDate && moment(logDate).isValid()
                                ? moment(logDate).format("llll")
                                : "N/A"}
                            </small>
                          </div>
                          {by && (
                            <div className="small text-muted mb-1">
                              By: <strong>{by}</strong>
                            </div>
                          )}
                          {!!reason && (
                            <div
                              className="small mt-2 p-2 rounded"
                              style={{ backgroundColor: "#f7f9fc" }}
                            >
                              <strong>Remark:</strong> {reason}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          }
        />
      )}
    </tr>
  );
};
